import React from "react";

import { Context } from "../context";
import { Props } from "./types";
import styles from "./styles.scss";

function ScrollZone({ id, orientation = "vertical", children }: Props) {
  const { getGutters } = React.useContext(Context);
  const root = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (!root.current) return;

    const origin = root.current;
    const scroll = (event: WheelEvent) => {
      const foundGutter = getGutters().find((g) => g.id === id);
      if (!foundGutter?.ref.current) return;

      event.preventDefault();

      const target = foundGutter.ref.current;

      if (orientation === "vertical") {
        target.scrollTop += event.deltaY;
      }

      if (orientation === "horizontal") {
        target.scrollLeft += event.deltaX;
      }
    };

    origin.addEventListener("wheel", scroll, { passive: false });

    return () => {
      origin.removeEventListener("wheel", scroll);
    };
  }, [id, orientation]);

  return (
    <div ref={root} className={styles.scrollZone}>
      {children}
    </div>
  );
}

export { ScrollZone };
